export default "Saml og dekorer sten som flotte, blussende gløder og bliv klar til ”flyt gløden-stafet”.";